import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  const {
    scrollYProgress
  } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 300,
    damping: 40
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-ink font-sans text-paper" data-id="element-187" data-mp="29nkjq2ohc7v">
      <motion.div aria-hidden style={{
      scaleX: progress
    }} className="fixed inset-x-0 top-0 z-[60] h-1 origin-left bg-signal" data-id="element-188" data-mp="2bgt5awuq6ii" />
      <Navbar data-id="element-189" data-mp="c7jsk90bjr1r" />
      <main data-id="element-190" data-mp="c6s6bosm35o5">
        <Outlet data-id="element-191" data-mp="c68rigy9cxec" />
      </main>
      <Footer data-id="element-192" data-mp="c5ywgeycw01s" />
    </div>;
}